export default "__VITE_ASSET__CyTv8YYe__"